// src/components/layout/PageHeader.jsx
import React, { useContext, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FiAlignRight, FiArrowLeft } from "react-icons/fi";
import { NavigationContext } from "../../../contentApi/navigationProvider";
import useTranslations from "../../../hooks/useTranslations";
import useUserLanguage from "../../../hooks/useUserLanguage";

const PageHeader = ({ children }) => {
  const { activeParent, activeChild, setNavigationOpen } = useContext(NavigationContext);
  const [openSidebar, setOpenSidebar] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const lang = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = (key, def) => translations[key] || def;

  const isCreate    = pathname.includes("/create");
  const isEdit      = pathname.includes("/edit");
  const isPreview   = pathname.includes("/view");
  const isTranslate = pathname.includes("/translation");
  const isCategory  = pathname.includes("/category");
  const isTrash     = pathname.includes("/trash");
  const isSelect    = pathname.includes("/select");
  const isQuestions = pathname.includes("/questions");
  const isScore     = pathname.includes("/score");

  // yalın liste sayfasında mıyız? (işlem sayfaları değil)
  const isBase = !(
    isSelect || isCreate || isEdit || isPreview || isTranslate || isQuestions || isTrash
  );

  // /admin/modules/edit/:slug/select vb. için slug yakalama
  const parts = pathname.split("/");
  const slug = parts[4];

  // 1) her zaman parent
  const crumbs = [activeParent];

  // 2) ikinci kırıntı
  if (isCategory) {
    crumbs.push(t("BREADCRUMB_CATEGORY"));
  } else if (isScore) {
    // kategori olsun/olmasın ikinci sıraya "Puan Açıklamaları"
    crumbs.push(t("BREADCRUMB_SCORE_COMMENTS"));
  } else {
    crumbs.push(
      activeChild && activeChild !== activeParent
        ? activeChild
        : t("BREADCRUMB_LIST")
    );
  }

  // 3) işlem sayfaları (create/edit/…)
  if (isSelect)            crumbs.push(t("BREADCRUMB_LIST_ITEM_ADD"));
  else if (isCreate)       crumbs.push(t("BREADCRUMB_CREATE"));
  else if (isEdit)         crumbs.push(t("BREADCRUMB_EDIT"));
  else if (isPreview)      crumbs.push(t("BREADCRUMB_PREVIEW"));
  else if (isTranslate)    crumbs.push(t("BREADCRUMB_TRANSLATION"));
  else if (isQuestions)    crumbs.push(t("BREADCRUMB_QUESTIONS"));
  else if (isTrash)        crumbs.push(t("BREADCRUMB_TRASH"));
  // yalnızca LISTE sayfasında ve kategori içinden score'a gelindiyse
  // üçüncü kırıntıyı tekrar "Puan Açıklamaları" yap
  else if (isBase && isScore && isCategory) {
    crumbs.push(t("BREADCRUMB_SCORE_COMMENTS"));
  }
  // (kategori yok ve base sayfadaysak 3. kırıntı eklemiyoruz → çift yazma yok)

  // parent tıklanabilir mi?
  const clickableParent = isCategory || isSelect;

  const handleParentClick = (e) => {
    e.preventDefault();
    if (isSelect) {
      navigate(`/admin/modules/edit/${slug}`);
    } else if (isCategory) {
      // kategori mantığınız uygunsa: bir adım geri (veya istediğiniz route)
      navigate(-((crumbs.length - 1)));
    }
  };

  return (
    <div className="page-header">
      <div className="page-header-left d-flex align-items-center">
        <div className="page-header-title">
          <h5 className="m-b-10 text-capitalize">
            {clickableParent ? (
              <a
                href="#"
                onClick={handleParentClick}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                {crumbs[0]}
              </a>
            ) : (
              <span>{crumbs[0]}</span>
            )}
          </h5>
        </div>

        <ul className="breadcrumb">
          {crumbs.slice(1).map((title, idx) => {
            const at = idx + 1;
            const isLast = at === crumbs.length - 1;
            return (
              <li key={idx} className="breadcrumb-item text-capitalize">
                {isLast ? (
                  title
                ) : (
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(-((crumbs.length - 1) - at));
                    }}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {title}
                  </a>
                )}
              </li>
            );
          })}
        </ul>
      </div>

      <div className="page-header-right ms-auto">
        <div className={`page-header-right-items ${openSidebar ? "page-header-right-open" : ""}`}>
          <div className="d-flex d-md-none">
            <Link
              to="#"
              onClick={() => setOpenSidebar(false)}
              className="page-header-right-close-toggle"
            >
              <FiArrowLeft size={16} className="me-2" />
              <span>{t("BACK")}</span>
            </Link>
          </div>
          {children}
        </div>

        <div className="d-md-none d-flex align-items-center">
          <Link
            to="#"
            onClick={() => setNavigationOpen(true)}
            className="page-header-right-open-toggle"
          >
            <FiAlignRight className="fs-20" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
